import { render } from "./Startups.vue?vue&type=template&id=2e1a416a&scoped=true"
import script from "./Startups.vue?vue&type=script&lang=js"
export * from "./Startups.vue?vue&type=script&lang=js"

import "./Startups.vue?vue&type=style&index=0&id=2e1a416a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2e1a416a"

export default script